import {
  CALCULATIONS_CALL_API_SUCCESS,
  CALCULATIONS_SET_PARAMETER_VALUE,
  CALCULATIONS_SWITCH_POROUS_STORAGE,
  CALCULATIONS_SWITCH_UNDERDRAIN,
  CALCULATIONS_VOLUME_OPTIMIZED, GLOBAL_PROJECT_TYPE_CHAMBER,
  SYSTEM_END_GENERATION,
  SYSTEM_START_GENERATION,
  VOLUME_END_OPTIMIZER,
  VOLUME_START_OPTIMIZER,
  SHOW_GENERATE_ALERT, IS_DIRTY
} from "../lib/types";
import {
  getScaledValue as _getScaledValue,
  getUnscaledValue as _getUnscaledValue
} from "../lib/calculations";

export const setCalculatedVolume = ( volume, calculations, manifoldSizing ) => ( dispatch, getState ) => {
  const { globals, pipeGlobals, pipeBed } = getState();
  dispatch({
    type: CALCULATIONS_CALL_API_SUCCESS,
    payload: {
      volume,
      calculations,
      manifoldSizing,
      chamberTypeName: globals.chamberType.name,
      pipeTypeName: pipeGlobals.pipeFitting._name,
      pipeBedLength: pipeBed.stoneBedDimensions.height,
      pipeBedWidth: pipeBed.stoneBedDimensions.width
    }
  });
};

export const setParameterValue = ( param, value ) => dispatch => {
  let newVal = value;
  if (param === "storageVolume" && isNaN(value)) {
    newVal = 0;
  }
  dispatch({
    type: CALCULATIONS_SET_PARAMETER_VALUE,
    payload: {
      param,
      value: newVal
    }
  });
  dispatch({
    type: IS_DIRTY,
    payload: true
  });
};

export const switchPorousStorage = () => dispatch => {
  dispatch({
    type: CALCULATIONS_SWITCH_POROUS_STORAGE
  });
};

export const switchUnderdrain = () => dispatch => {
  dispatch({
    type: CALCULATIONS_SWITCH_UNDERDRAIN
  });
};

export const setResultingOptimizedRows = chamberRows => dispatch => {
  dispatch({
    type: CALCULATIONS_VOLUME_OPTIMIZED,
    payload: {
      chamberRows
    }
  });
};

export const startSystemGeneration = () => dispatch => {
  dispatch({ type: SYSTEM_START_GENERATION });
};

export const endSystemGeneration = () => dispatch => {
  dispatch({ type: SYSTEM_END_GENERATION });
};

export const startVolumeOptimizer = () => dispatch => {
  dispatch({ type: VOLUME_START_OPTIMIZER });
};

export const endVolumeOptimizer = () => dispatch => {
  dispatch({ type: VOLUME_END_OPTIMIZER });
};

export const getScaledValue = value => ( dispatch, getState ) => {
  const { globals, pipeGlobals } = getState();
  const { scalePixels, scaleValue } = globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? globals : pipeGlobals;

  return _getScaledValue(scalePixels, scaleValue, value);
};

export const getUnscaledValue = value => ( dispatch, getState ) => {
  const { globals, pipeGlobals } = getState();
  const { scalePixels, scaleValue } = globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER ? globals : pipeGlobals;

  return _getUnscaledValue(scalePixels, scaleValue, value);
};

export const setShowGenerateAlert = ( value ) => ( dispatch, getState ) => {
  dispatch({
    type: SHOW_GENERATE_ALERT,
    payload: value
  });
};



// WEBPACK FOOTER //
// ./src/actions/calculations-actions.js